// istanbul ignore file
import React from 'react'
import { Box, Grid } from '@mui/material'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import sliderBackground from '../../../assets/Slider-BG.png'
import slider1 from '../../../assets/dummy_800x400.png'
import slider2 from '../../../assets/dummy_800x400_2.png'
import slider3 from '../../../assets/dummy_800x400_3.png'

const DefaultComponent: React.FC = () => {
  return (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
            <Box
              sx={{
                backgroundImage: `url(${sliderBackground})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                width: 'auto',
                height: '70vh',
                margin: { xs: '20px 10px', sm: '30px 15px', md: '45px 20px' },
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                boxSizing: 'border-box'
              }}
            >
              <Box
          width="100%"
          maxWidth="1200px"
          padding={{ xs: '20px', sm: '40px', md: '60px' }}
              >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
                <Slider
                className='get-started'
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                nextArrow={
                  <div
                  style={{
                    backgroundColor: '#464646',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '20px',
                    cursor: 'pointer'
                  }}
                  >
                  {'>'}
                  </div>
                }
                prevArrow={
                  <div
                  style={{
                    backgroundColor: '#464646',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '20px',
                    cursor: 'pointer'
                  }}
                  >
                  {'<'}
                  </div>
                }
                >
                <Box>
              <img
                src={slider1}
                alt="Slide 1"
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  objectFit: 'cover'
                }}
              />
                </Box>
                <Box>
              <img
                src={slider2}
                alt="Slide 2"
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  objectFit: 'cover'
                }}
              />
                </Box>
                <Box>
              <img
                src={slider3}
                alt="Slide 3"
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  objectFit: 'cover'
                }}
              />
                </Box>
                </Slider>
            </Grid>
          </Grid>
              </Box>
            </Box>
            </Grid>
          </Grid>
        </Box>
  )
}

export default DefaultComponent
